import React from 'react';
import { Button, ButtonTheme } from '@apply/components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLessThan } from '@fortawesome/free-solid-svg-icons';

export interface ApplicationEntrySaveAndExitButtonProps {
    previousStepButtonClick?: () => void;
    previousStepButtonVisible?: boolean;
}

export const ApplicationEntryBackButton: React.FC<ApplicationEntrySaveAndExitButtonProps> = ({
    previousStepButtonClick,
    previousStepButtonVisible = false,
}) => {
    const handleClick = async () => {
        if (previousStepButtonClick) {
            previousStepButtonClick();
        } else {
            alert('Back button not implemented!s');
        }
    };

    return (
        <>
            <div style={{ float: 'right' }}>
                <Button
                    id='applicationEntry-backButton'
                    dataTestid='applicationEntryBackButton'
                    theme={ButtonTheme.LinkBlue}
                    handleClick={handleClick}
                    visible={previousStepButtonVisible}
                >
                    <span style={{ paddingRight: '5px' }}>
                        <FontAwesomeIcon icon={faLessThan} />
                    </span>
                    Back
                </Button>
            </div>
        </>
    );
};
